import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddEditMonitoringCompanyComponent } from '../shared/components/add-edit-monitoring-company/add-edit-monitoring-company.component';
import { protectGuard } from '../shared/guards/protect.guard';
import { AppUserFeedbackComponent } from './pages/app-user-feedback/app-user-feedback.component';
import { AddEditCheckpointComponent } from './pages/checkpoints/add-edit-checkpoint/add-edit-checkpoint.component';
import { CheckpointsComponent } from './pages/checkpoints/checkpoints.component';
import { ViewCheckpointComponent } from './pages/checkpoints/view-checkpoint/view-checkpoint.component';
import { ClientsComponent } from './pages/clients/clients.component';
import { ViewClientComponent } from './pages/clients/view-client/view-client.component';
import { CompanyProfileComponent } from './pages/company-profile/company-profile.component';
import { MessageComponent } from './pages/hol-and-message/chat/message/message.component';
import { AddEditHandOverLogComponent } from './pages/hol-and-message/hand-over-log/hand-over-log/add-edit-hand-over-log/add-edit-hand-over-log.component';
import { HandOverLogComponent } from './pages/hol-and-message/hand-over-log/hand-over-log/hand-over-log.component';
import { HomeComponent } from './pages/home/home.component';
import { AddIncidentComponent } from './pages/incidents/add-incident/add-incident.component';
import { IncidentsComponent } from './pages/incidents/incidents.component';
import { ReviewIncidentComponent } from './pages/incidents/review-incident/review-incident.component';
import { ViewIncidentComponent } from './pages/incidents/view-incident/view-incident.component';

import { AddJobComponent } from './pages/jobs/add-job/add-job.component';
import { InvoiceJobsComponent } from './pages/jobs/invoice-jobs/invoice-jobs.component';
import { JobDetailsComponent } from './pages/jobs/job-details/job-details.component';
import { JobReviewComponent } from './pages/jobs/job-review/job-review.component';
import { JobsComponent } from './pages/jobs/jobs.component';
import { PatrolDetailComponent } from './pages/jobs/patrol-detail/patrol-detail.component';
import { MonitoringCompanyComponent } from './pages/monitoring-company/monitoring-company.component';
import { PagesComponent } from './pages/pages.component';
import { ReportsComponent } from './pages/reports/reports.component';

import { GroupedJobTypesComponent } from './pages/grouped-job-types/grouped-job-types.component';
import { ConditionalRosterJobsComponent } from './pages/roster-shifts/conditional-roster-jobs/conditional-roster-jobs.component';
import { RosterShiftsComponent } from './pages/roster-shifts/roster-shifts.component';

import { SitesComponent } from './pages/sites/sites.component';
import { ViewSiteComponent } from './pages/sites/view-site/view-site.component';
import { SosWelfareChecksComponent } from './pages/sos-welfare-checks/sos-welfare-checks.component';
import { SubscriptionComponent } from './pages/subscription/subscription.component';
import { AddEditUserPromptComponent } from './pages/user-prompts/add-edit-user-prompt/add-edit-user-prompt.component';
import { UserPromptsComponent } from './pages/user-prompts/user-prompts.component';
import { UserUpdateLogComponent } from './pages/user-update-log/user-update-log.component';
import { UserStats } from './pages/users/user-stats/user-stats';

import { UsersComponent } from './pages/users/users.component';

import { AddRunSheetComponent } from './pages/runsheet/add-runsheet/add-runsheet.component';
import { RunSheetDetailComponent } from './pages/runsheet/runsheet-detail/runsheet-detail.component';
import { RunSheetComponent } from './pages/runsheet/runsheet.component';
import { PrintInvoiceComponent } from './pages/jobs/invoice-jobs/print-invoice/print-invoice.component';
import { SopComponent } from './pages/sop/sop.component';
import { AddSopComponent } from './pages/sop/add-sop/add-sop.component';
import { ViewSopComponent } from './pages/sop/view-sop/view-sop.component';
import { UserEventLogComponent } from './pages/user-event-log/user-event-log.component';
import { SubContractorsComponent } from './pages/sub-contractors/sub-contractors.component';
import { AddEditSubContractor } from './pages/sub-contractors/add-edit-sub-contractor/add-edit-sub-contractor';
import { UserLiveDataComponent } from '../shared/components/user-live-data/user-live-data.component';
import { PinnedMessageComponent } from './pages/hol-and-message/pinned-message/pinned-message.component';
import { AddEditPinnedMessageComponent } from './pages/hol-and-message/pinned-message/add-edit-pinned-message/add-edit-pinned-message.component';
import { UserProfileComponent } from '../profile/user-profile/user-profile.component';
import { RosterComponent } from './pages/roster/roster.component';
import { LeaveComponent } from './pages/roster/leave/leave.component';

const routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    canActivate: [protectGuard],
    canActivateChild: [protectGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'dashboard',
        component: HomeComponent,
      },

      {
        path: 'jobs',
        component: JobsComponent,
      },

      {
        path: 'add-job',
        component: AddJobComponent,
      },

      {
        path: 'job-detail/:jobKey',
        component: JobDetailsComponent,
      },
      {
        path: 'job-review/:jobKey',
        component: JobReviewComponent,
      },

      {
        path: 'client',
        pathMatch: 'full',

        component: ClientsComponent,
      },
      {
        path: 'view-client',
        component: ViewClientComponent,
      },

      {
        path: 'view-route',
        component: PatrolDetailComponent,
      },

      {
        path: 'profile',
        component: UserProfileComponent,
      },

      {
        path: 'company-profile',
        component: CompanyProfileComponent,
      },

      {
        path: 'subscription',
        component: SubscriptionComponent,
      },

      {
        path: 'users',
        component: UsersComponent,
      },
      {
        path: 'credentials',
        component: UsersComponent,
      },

      {
        path: 'checkpoints',
        component: CheckpointsComponent,
      },
      {
        path: 'add-checkpoint',
        component: AddEditCheckpointComponent,
      },
      {
        path: 'view-checkpoints',
        component: ViewCheckpointComponent,
      },

      {
        path: 'user-updates',
        component: UserUpdateLogComponent,
      },
      {
        path: 'user-events',
        component: UserEventLogComponent,
      },

      {
        path: 'reports',
        component: ReportsComponent,
      },
      {
        path: 'support',
        component: AppUserFeedbackComponent,
      },

      {
        path: 'job-types',
        component: GroupedJobTypesComponent,
      },
      {
        path: 'monitoring-company',
        component: MonitoringCompanyComponent,
      },
      {
        path: 'view-company',
        component: AddEditMonitoringCompanyComponent,
      },
      {
        path: 'add-company',
        component: AddEditMonitoringCompanyComponent,
      },
      {
        path: 'incidents',
        component: IncidentsComponent,
      },
      {
        path: 'add-incident',
        component: AddIncidentComponent,
      },
      {
        path: 'view-incident',
        component: ViewIncidentComponent,
      },
      {
        path: 'review-incident',
        component: ReviewIncidentComponent,
      },

      {
        path: 'roster',
        component: RosterShiftsComponent,
      },

      {
        path: 'sos-welfare-alerts',
        component: SosWelfareChecksComponent,
      },

      {
        path: 'mobile-forms',
        component: UserPromptsComponent,
      },
      {
        path: 'mobile-form',
        component: AddEditUserPromptComponent,
      },
      {
        path: 'sites',
        pathMatch: 'full',

        component: SitesComponent,
      },
      {
        path: 'view-site',
        component: ViewSiteComponent,
      },
      {
        path: 'hand-over-log',
        component: HandOverLogComponent,
      },
      {
        path: 'add-hand-over-log',
        component: AddEditHandOverLogComponent,
      },
      { path: 'view-hand-over-log', component: AddEditHandOverLogComponent },
      {
        path: 'message',
        component: MessageComponent,
      },

      {
        path: 'invoice-jobs',
        component: InvoiceJobsComponent,
      },

      {
        path: 'print-invoice',
        component: PrintInvoiceComponent,
      },
      {
        path: 'roster-jobs',
        component: ConditionalRosterJobsComponent,
      },

      {
        path: 'user-stats',
        component: UserStats,
      },
      // runsheet routes
      {
        path: 'runsheet',
        component: RunSheetComponent,
      },
      {
        path: 'add-runsheet',
        component: AddRunSheetComponent,
      },
      { path: 'view-runsheet', component: RunSheetDetailComponent },
      // sop routes
      {
        path: 'sop',
        component: SopComponent,
      },
      {
        path: 'add-sop',
        component: AddSopComponent,
      },
      { path: 'view-sop', component: ViewSopComponent },
      //  subcontractor routes
      {
        path: 'sub-contractors',
        component: SubContractorsComponent,
      },

      { path: 'view-sub-contractor', component: AddEditSubContractor },
      { path: 'operations-overview', component: UserLiveDataComponent },

      //pinned-message
      { path: 'pinned-messages', component: PinnedMessageComponent },
      {
        path: 'add-edit-pinned-message',
        component: AddEditPinnedMessageComponent,
      },
      {
        path: 'schedule',
        component: RosterComponent,
      },
      {
        path: 'mng-leave',
        component: LeaveComponent,
      },

      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
